import { memo } from 'react';

import { cn } from '../../lib/styles';

export interface HintProps {
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
}

const HintBase = ({ icon, children, className, iconClassName, textClassName }: HintProps) => {
  return (
    <div
      className={cn(
        'flex gap-2 mt-2 rounded-xl p-2.5 border border-border-default bg-bg-sur-secondary dark:bg-gray-14/80 cursor-auto dark:border-border-default/60',
        className,
      )}
    >
      {icon && <div className={cn('size-5 min-w-5', iconClassName)}>{icon}</div>}

      <div
        className={cn('font-body-sm text-text-primary whitespace-pre-wrap text-left dark:text-white/80', textClassName)}
      >
        {children}
      </div>
    </div>
  );
};

export const Hint = memo(HintBase);
